import React from "react";
import Input from "../../../../../../../components/input";
import Button from "../../../../../../../components/button";
import {promoCodeLength} from "../../../../../../../constants/maxLenghtAtrribute";

export const PromoCode = props => {
  return (
    <React.Fragment>
      <div className="form-control">کد تخفیف</div>
      <div className="form-control">
        <div className="input">
          <Input
            maxLength={promoCodeLength}
            type="text"
            meta={{ error: "" }}
            input={{
              value: props.promoCode,
              onChange: data => props.onChange(data)
            }}
            disabled={props.disabledInput}
            placeholder="ورود کد تخفیف"
          />
        </div>
        <div className="text">
          <Button
            btn={props.promoButtonHandler === "submit" ? "secondary" : "error"}
            onClick={
              props.promoButtonHandler === "submit"
                ? () => props.registerPromoCode()
                : () => props.unregisterPromoCode()
            }
            disabled={props.promoCode === ""}
            loading={props.calculatePriceLoading}
          >
            {props.promoButtonHandler === "submit"
              ? "ثبت کد تخفیف"
              : "حذف کد تخفیف"}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};
